<!-- <template>
	<div class="module_container full" style="position: relative;">
		<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:ref="moduleName+'_list'">
		</vxe-grid>
		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
		<vxe-modal v-model="wlnorderShow" width="400" height="auto" :title="wlnorderTitle" show-footer size="mini"
			@confirm="wlnorderSubmit">
			<el-form ref="form" :model="wlnorderForm" label-width="80px" size="mini">
				<el-form-item label="线上单号">
					<el-input v-model="wlnorderForm.order" placeholder=""></el-input>
				</el-form-item>
			</el-form>
		</vxe-modal>
	</div>
</template>
<style>

</style>
<style scoped>

</style> -->
<script>
	import listBase from '@_system/components/base/list.vue'

	export default {
		extends: listBase,
		name: 'saleorderIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'saleorder',
				windowName: '销售单',
				windowType: 'window',
				wlnorderShow: false,
				wlnorderTitle: '线上单号',
				wlnorderForm: {
					order: ''
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			push(row) {
				this.$api[this.moduleName].push({id:row.id}).then(()=>{
					this.$message.success('操作成功')
				})
			},
			wlnorder(row) {
				this.wlnorderTitle = row.code
				this.wlnorderForm.order = row.wlnorder
				this.wlnorderShow = true
				this.row = row
			},
			wlnorderSubmit(){
				this.$api.saleorder.wlnorder(this.row.id, this.wlnorderForm).then(() => {
					this.$message.success('操作成功')
					this.wlnorderShow = false
					this.wlnorderForm.order = ''
					this.customreload()
				})
			}
		},
		components: {

		}
	}
</script>
